import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between',
  },
  logTimelineIcon: {
    maxWidth: '100%',
  },
  textSecondary: {
    color: theme.palette.text.subtitle,
  },
  loadingContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    minHeight: 100,
  },
  timeline: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    height: '100%',
    left: 0,
    position: 'absolute',
    top: 4,
    width: 20,
  },
  lastItem: {
    height: 'auto',
  },
  circle: {
    backgroundColor: '#CBCBCB',
    borderRadius: '100%',
    minHeight: 8,
    minWidth: 8,
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
  },
  line: {
    backgroundColor: '#fff',
    border: 'none',
    borderLeft: `1px solid #CBCBCB`,
    color: '#fff',
    height: 'calc(100% - 3px)',
    margin: 0,
    width: 1,
  },
  item: {
    fontWeight: 500,
  },
  link: {
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
}));

export default useStyles;
